 
         <mat-form-field class="full-width">
            <mat-label> Liste des agences <mat-icon  aria-label="help icon">help</mat-icon> </mat-label> 
            <mat-chip-list #chipList aria-label="agence selection">
              <mat-chip
                *ngFor="let agence of selectedAgenceString"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(agence)">
                {{agence}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input
                matTooltip="Sélectionnez les agences dans la liste" 
                #agenceInput
                [formControl]="agenceCtrl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)">
            </mat-chip-list>
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let agence of filteredAgences | async" [value]="agence" matTooltip="{{agence}}">
                {{agence}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
   
  
   
   